import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ROWS = [["owner_insurance", "Insurance leads"], ["owner_loan", "Loan leads"], ["owner_all", "Any lead (if the above is empty)"]];

export function DefaultLeadOwner() {
  const [v, setV] = useState(null);
  const [staff, setStaff] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/lead-defaults").then(({ data }) => setV(data)).catch(() => setV({}));
    api.get("/users").then(({ data }) => setStaff(data.filter((u) => u.active !== false && u.role !== "super_admin")));
  }, []);
  const save = async () => {
    setBusy(true);
    try { await api.put("/lead-defaults", v); toast.success("Default lead owner saved"); } catch (ex) { toast.error(apiError(ex.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!v) return null;
  return (
    <Card className="p-5 mb-6" data-testid="default-owner-card">
      <div className="flex items-center gap-2 font-bold"><UserCheck className="h-4 w-4 text-primary" />Default lead owner</div>
      <p className="text-xs text-muted-foreground mt-1 mb-4">Website, loan apply and Meta leads that match no area rule go to this person instead of staying unassigned. Leads added or imported by staff stay with that staff member.</p>
      <div className="grid sm:grid-cols-3 gap-3">{ROWS.map(([k, l]) => (
        <div key={k}><div className="text-xs text-muted-foreground mb-1">{l}</div>
          <Select value={v[k] || "none"} onValueChange={(x) => setV({ ...v, [k]: x === "none" ? null : x })}>
            <SelectTrigger data-testid={`default-${k}`}><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="none">Nobody (managers get an alert)</SelectItem>{staff.map((u) => <SelectItem key={u.id} value={u.id}>{u.name} · {u.employee_id}</SelectItem>)}</SelectContent>
          </Select></div>))}</div>
      <Button className="mt-4" onClick={save} disabled={busy} data-testid="default-owner-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save"}</Button>
    </Card>
  );
}
